import { NgModule } from '@angular/core';
import { Component, OnInit, Inject, ViewChild, ElementRef  } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {FormsModule} from '@angular/forms';


export interface AlertaRadio {
    tituloAlerta: string;
    textoAlerta: string;
    tipoInput: string;
    textoCancel: string;
    textoConfirm: string;
    textoInput: string;
    valorInput: string;
    nomeInput: string;
    beFocused: boolean;
    dataRadio: any[];
}

@Component({
    selector: 'alerta-radio',
    templateUrl: './alerta-radio.html',
    styleUrls: ['./alerta-radio.css']
  })
  export class AlertaRadioDialog {
    @ViewChild("inputIA") inputEl: ElementRef;
    cartaoEscolhido: any;

    constructor(
      public dialogRef: MatDialogRef<AlertaRadioDialog>,
      @Inject(MAT_DIALOG_DATA) public data: AlertaRadio) {}
  

    ngOnInit(){
      setTimeout(() => {
        if (this.data.beFocused){
          this.inputEl.nativeElement.focus();
        }
      }, 500);
    }
    radioC(cartao, bandeira) :void{
      console.log(cartao, bandeira);
      this.cartaoEscolhido = cartao + " - " + bandeira;
    }

    onNoClick(): void {
      this.dialogRef.close(false);
      //return false;
    }
    onConfirmClick() :void {
      this.dialogRef.close(this.cartaoEscolhido);
        // if (this.data.valorInput == '' || this.data.valorInput == undefined){

        // }
        // else{
        //   this.dialogRef.close(this.data.valorInput);
        // }
        
    }
  
}